'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Image, TouchableWithoutFeedback, Animated} from 'react-native';
import Icon from '../../../../../../components/Icon';
import { observer, inject } from 'mobx-react';
import styles from './style';

import QImageSet from '../../../../../../assets/QImageSet';
import {getScreenSize, scale} from "../../../../../../common/utils";


@inject(stores => {
    const {searchDataStore} = stores,
        {depCity, arrCity, exchangeCity, getDepCity, getArrCity, flightType, canExchangePlace, handleCityList,
            windowWidth, destCityListComp, depCityListComp} = searchDataStore;
    return {
        windowWidth,
        depCity,
        arrCity,
        exchangeCity,
        getDepCity,
        getArrCity,
        flightType,
        destCityListComp,
        depCityListComp,
        canExchangePlace
    };
})

@observer
class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            switchDeg: new Animated.Value(0)
        }
    }

    openCityList = (showType) => {
        GodEye.log({
            r: 'seach_box_open_city',
            type: showType
        })
        if(showType === 'dep') {
            this.props.depCityListComp.show()
        } else {
            this.props.destCityListComp.show()

        }
    };

    exchangeCity = () => {
        GodEye.log({
            r: 'city_reverse'
        });
        if(this.props.canExchangePlace) {
            this.runSwitchAnimate();
            this.props.exchangeCity()
        }
    };

    runSwitchAnimate() {
        Animated.timing(this.state.switchDeg, {
            toValue: 1,
            duration: 500
        }).start(() => {
            this.setState({
                switchDeg: new Animated.Value(0)
            })
        });
    }

    render() {
        const {depCity, arrCity, canExchangePlace} = this.props || {};
        const resizeMinWidth = scale(this.props.windowWidth / 2 - 60);
        const addClass = (depCity.length > 5 || arrCity.length > 5) ?  {fontSize: 18, maxWidth: 127, minWidth: resizeMinWidth} : {minWidth:  resizeMinWidth};
        return (
            <View style={styles.searchPlaceBoxWrapper}>
                <TouchableOpacity style={[styles.searchIcon, canExchangePlace ? {color: 'blue'} : '']} onPress={this.exchangeCity}>
                    <Animated.View style={{transform: [{rotateZ: this.state.switchDeg.interpolate({
                                inputRange:[0,1],
                                outputRange:['0deg','360deg']
                            })}]}}>
                        {canExchangePlace ? <Image source={{uri: QImageSet.cityCircle}} style={[styles.searchIconCircle]}/> : null}
                    </Animated.View>
                    <Icon name='flight' color={canExchangePlace ? '#00cad8': '#999999' } size={24} style={styles.searchIconFlight}/>
                </TouchableOpacity>
                <View style={styles.searchPlaceBox}>
                    <TouchableWithoutFeedback onPress={()=>{this.openCityList('dep')}}>
                        {depCity
                            ? <Text numberOfLines={1} ellipsizeMode={'tail'} style={[styles.searchPlaceText, styles.dep, addClass]}>
                                {depCity}
                            </Text>
                            : <Text style={[styles.searchPlaceNoCityText]}>请选出发地</Text>}
                    </TouchableWithoutFeedback>
                    <TouchableWithoutFeedback onPress={()=>{this.openCityList('dest')}}>
                        {arrCity
                            ? <Text numberOfLines={1} ellipsizeMode={'tail'} style={[styles.searchPlaceText, styles.arr, addClass]}>{arrCity}</Text>
                            : <Text style={[styles.searchPlaceNoCityText, styles.arr]}>请选择到达地</Text>}

                    </TouchableWithoutFeedback>
                </View>
            </View>
        )
    }
}

export default SearchBox;
